import React, { useState } from "react";
import "./Sidebar.css";
import MainLogo from "../../images/qcr-logo2.png";
import Navbar from "react-bootstrap/Navbar";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import SubMenu from './SubMenu';

const Nav = styled.div`
    ${'' /* background: #15171c; */}
    height: 100px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
`;

  const NavIcon = styled(Link)`
  font-size: 2rem;
  height:100px;
  display:flex;
  justify-content:flex-start;
  align-items:center;
  `;

  const SidebarNav = styled.nav`
${'' /* background: #15171c; */}
width:250px;
// height:100vh;
display:flex;  
`;

  const SidebarWrap = styled.div`
  width:100%;
  `;

  const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false)
  
  const showSidebar = () => setSidebar(!sidebar)
    


    return <>
    <div className="Sidebar">
        <div className="Sidebar-logo">
          <Navbar.Brand href="/Investigator/Dashboard">
            <img src={MainLogo} alt="QCR" width={130} />
          </Navbar.Brand>
        </div>
    {/* <Nav>
    <NavIcon to='#'>
   <FaIcons.FaBars onClick={showSidebar} />
    </NavIcon>
    </Nav> */}
    <SidebarNav sidebar={sidebar}>
      <SidebarWrap>
      {/* <NavIcon to='#'>
   <AiIcons.AiOutlineClose onClick={showSidebar}/>
    </NavIcon> */}
    {SidebarData.map((item, index) => {
      return <SubMenu item={item} key={index} />;
    })}

      </SidebarWrap>
    </SidebarNav>
    </div>
    </>;
  };

export default Sidebar;